/**
 * Date and time constants for the booking system
 * Contains all date/time related configurations used throughout the application
 */

/**
 * Standard time ranges for booking slots
 */
export const TIME_RANGES = {
    MORNING: { start: "08:00", end: "12:00" },
    AFTERNOON: { start: "13:00", end: "17:00" },
    FULL_DAY: { start: "08:00", end: "17:00" }
} as const;

/**
 * Business hours configuration
 */
export const BUSINESS_HOURS = {
    START: "08:00",
    END: "17:00",
    LUNCH_START: "12:00",
    LUNCH_END: "13:00"
} as const;

/**
 * Time format configurations
 */
export const TIME_FORMATS = {
    DISPLAY: "HH:mm",
    VALUE: "HH:mm",
    ISO_DATE: "YYYY-MM-DD",
    DISPLAY_DATE: "dd.MM.yyyy"
} as const;
